
import store from '@/state/store';
import { getToken, setToken } from '@/services/http.service';

export default (https) => {
  // ✅ Setup interceptor before returning the service
  https.interceptors.response.use(
    response => response,
    async error => {
      if (error.response && error.response.status === 401) {
        if (!error.config._retry) {
          error.config._retry = true;
          try {
            const token = getToken();
            if (token) {
              // CT-09: this logout call goes through the same intercepted client.
              // If the session is already expired, IT also 401s, and without
              // _retry pre-set on its own config, that response re-enters this
              // same handler on a fresh config object (whose _retry is unset)
              // and fires another logout — and so on, recursively. Marking this
              // request's config up front breaks the loop; the outer finally
              // block below still runs cleanup exactly once regardless.
              await https.post(`/logout`, { token }, { _retry: true });
            }
          } catch (logoutErr) {
            console.error('Auto logout failed:', logoutErr);
          } finally {
            localStorage.removeItem('token');
            sessionStorage.removeItem('token');
            store.dispatch('auth/clearUser');
            window.location.href = '/login'; // or router.push('/login');
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return {
    async loginUser(payload) {
        const response = await https.post(`/login`, payload);
        return response.data;
        
    },

    // registerUser()/verifyEmail() removed — public registration is disabled
    // server-side (POST /register returns 403, the route no longer exists) and
    // neither endpoint was called from anywhere in the app.

    async sendResetCode(payload) {
      return await https.post(`/send-password-reset-code`, payload);
    },
    
    async verifyOptViaEmail(payload) {
      try {
        const response = await https.post(`/verify-otp`, payload);
        const token = response.data.data?.access_token || response.data.data?.token || response.data.access_token || response.data.token;
        console.log(token, 'token');
        
        if (token) {
          setToken(token);
          localStorage.setItem('token', token);
        }
        
        return response.data;
      } catch (error) {
        console.error('Login failed:', error);
        throw error;
      }
    },
    async validateResetCode(payload) {
      return await https.post(`/verify-code`, payload);
    },
 async resendCode(payload) {
      return await https.post(`/verify-code`, payload);
    },
    async resetPassword(payload) {
      return await https.post(`/password-reset`, payload);
    },

    async changePasswordUser(payload) {
      return await https.post(`/update-password`, payload);
    },

    async changeProfileUser(payload) {
      return await https.post(`/update-profile`, payload);
    },

    reject() {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      if (token) {
        this.logOut();
      }
    },

    async logOut() {
      const token = getToken();
      console.log(token, 'token');
      try {
        await https.post(`/logout`, { token });
      } catch (error) {
        console.error('Logout failed:', error);
      } finally {
        if (token) {
          localStorage.removeItem('token');
          sessionStorage.removeItem('token');
          store.dispatch('auth/clearUser');
          window.location.href = '/login'; // or use router.push
        }
      }
    }
  };
};
